export const API_BASE_URL =
  "https://dashboard.chorusaccess.org/dashboard-service/api/v1/chorus";

export const API_BASE_URL_FOR_REPORT =
  "https://dashboard.chorusaccess.org/dashboard-service/api/v1/chorus";
